// extracted by mini-css-extract-plugin
module.exports = {"Container":"ConversionPanel_Container__idRWw","Grid":"ConversionPanel_Grid__2gy-g","DetailPanel":"ConversionPanel_DetailPanel__15OuH"};